var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1887 9.55771C20.6159 9.98495 20.6159 10.6775 20.1887 11.1046L12.8511 18.4423C12.4239 18.8693 11.7315 18.8693 11.3043 18.4423L7.81134 14.9491C7.38409 14.5221 7.38409 13.8295 7.81134 13.4025C8.23837 12.9753 8.93094 12.9753 9.35797 13.4025L12.0776 16.1221L18.6418 9.55771C19.0691 9.13068 19.7616 9.13068 20.1887 9.55771ZM28 14C28 21.7385 21.7374 28 14 28C6.26151 28 0 21.7374 0 14C0 6.26151 6.26257 0 14 0C21.7385 0 28 6.26257 28 14ZM25.8125 14C25.8125 7.47061 20.5285 2.1875 14 2.1875C7.47061 2.1875 2.1875 7.47147 2.1875 14C2.1875 20.5294 7.47147 25.8125 14 25.8125C20.5294 25.8125 25.8125 20.5285 25.8125 14Z",
    fill: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheck);
export default __webpack_public_path__ + "static/media/big-check.c82a6871.svg";
export { ForwardRef as ReactComponent };